import i18n from "../../../i18n"

export const professors = {
    department: i18n.t("fin_department"),
    professors:
        [
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1682/2079-d-ginoglou-2.jpg',
                fname: 'dimitrios',
                lname: 'gkinoglou',
                title: 'kathigitis',
                tel: '2310 891.688',
                email: 'ginogl@uom.edu.gr',
                building: 'ΗΘ3',
                office: '327'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1685/6161-a-zapranis-new-340x340-2.jpg',
                fname: 'achilleas',
                lname: 'zapranis',
                title: 'kathigitis',
                tel: '2310 891.690',
                email: 'zapranis@uom.edu.gr',
                building: 'ΗΘ4',
                office: '427'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1691/9925-negakis-front-2.jpg',
                fname: 'christos',
                lname: 'negkakis',
                title: 'kathigitis',
                tel: '2310 891.632',
                email: 'negakis@uom.edu.gr',
                building: 'ΗΘ',
                office: '322'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1684/2083-a-noulas-2.jpg',
                fname: 'thanasis',
                lname: 'noulas',
                title: 'kathigitis',
                tel: '2310 891.677',
                email: 'anoulas@uom.edu.gr',
                building: 'ΗΘ2',
                office: '221'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1686/2084-i-papanastasiou-2.jpg',
                fname: 'ioannis',
                lname: 'papanastasiou',
                title: 'kathigitis',
                tel: '2310 891.696',
                email: 'ginogl@uom.edu.gr',
                building: 'ΗΘ4',
                office: '426'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1690/5464-protogeros_id-2.jpg',
                fname: 'nikolaos',
                lname: 'protogeros',
                title: 'kathigitis',
                tel: '2310 891.681',
                email: 'proto@uom.edu.gr',
                building: 'ΗΘ',
                office: '226'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1697/2062-p-tachinakis-2.jpg',
                fname: 'panagiotis',
                lname: 'tachynakis',
                title: 'kathigitis',
                tel: '2310 891.564',
                email: 'tachinakis@uom.edu.gr',
                building: 'ΗΘ',
                office: '326'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/8016/7103-alexandridis-2.jpg',
                fname: 'antonios',
                lname: 'alexandridis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.611',
                email: 'alexandridis@uom.edu.gr',
                building: 'ΗΘ',
                office: '228'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1694/2060-livanis-2.jpg',
                fname: 'efstratios',
                lname: 'livanis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.685',
                email: 'slivanis@uom.edu.gr',
                building: 'ΗΘ',
                office: '225'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/6712/10099-7178-mavrag-2-2.jpg',
                fname: 'eleni',
                lname: 'mavragani',
                title: 'Αναπληρώτρια Καθηγήτρια',
                tel: '2310 891.625',
                email: 'mavragani@uom.edu.gr',
                building: 'ΗΘ',
                office: '328'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1707/10098-pmessis-2.jpg',
                fname: 'petros',
                lname: 'messis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.619',
                email: 'pmessis@uom.edu.gr',
                building: 'ΗΘ',
                office: '223'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1692/2061-s-papadopoulos-2.jpg',
                fname: 'simeon',
                lname: 'papadopoulos',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.665',
                email: 'spapado@uom.edu.gr',
                building: 'ΗΘ',
                office: '222'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/4981/1961-PavlatosOd-2.jpg',
                fname: 'odysseas',
                lname: 'pavlatos',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.659',
                email: 'opavlatos@uom.edu.gr',
                building: 'ΗΘ',
                office: '423'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1696/2493-asamara-2.jpg',
                fname: 'aggeliki',
                lname: 'samara',
                title: 'Αναπληρώτρια Καθηγήτρια',
                tel: '2310 891.523',
                email: 'asamara@uom.edu.gr',
                building: 'ΗΘ',
                office: '323'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/8846/8201-tziogkidis-340x340-2.jpg',
                fname: 'panagiotis',
                lname: 'tziogkidis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.699',
                email: 'giogkidisp@uom.edu.gr',
                building: 'ΗΘ',
                office: '325'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/11507/13754-trachanas-340x340-2.jpg',
                fname: 'emmanouil',
                lname: 'trachanas',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.672',
                email: 'etrachanas@uom.edu.gr',
                building: 'ΗΘ',
                office: '328'
            }
        ]
}
